module.exports = __webpack_public_path__ + "img/columnarIcon1.9ea91bd1.svg";